import { lazy } from "react";

// Lazy-loaded Admin Auth Containers
const ResetPasswordContainer = lazy(() => import("../containers/auth/ResetPasswordContainer"));
const SigninContainer = lazy(() => import("../containers/auth/SigninContainer"));
const SignupContainer = lazy(() => import("../containers/auth/SignupContainer"));

export const authAdminRoutes = [
  { path: "/Login", component: SigninContainer },
  { path: "/ResetPasswordAdmin", component: ResetPasswordContainer },
  { path: "/Register", component: SignupContainer },
];